
import { Component, input } from '@angular/core';
import { StepPosition } from '../../joyride.domain';

@Component({
  selector: 'td-wb-joyride-arrow',
  template: '',
  styleUrls: ['./joyride-arrow.component.scss'],
  host: {
    '[class.td-wb-joyride-arrow__top]': 'position() === stepPosition.TOP',
    '[class.td-wb-joyride-arrow__bottom]': 'position() === stepPosition.BOTTOM',
    '[class.td-wb-joyride-arrow__right]': 'position() === stepPosition.RIGHT',
    '[class.td-wb-joyride-arrow__left]': 'position() === stepPosition.LEFT'
  }
})
export class JoyrideArrowComponent {
  readonly position = input<StepPosition>(StepPosition.TOP);

  protected readonly stepPosition: typeof StepPosition = StepPosition;
}
